import { call, put, select, takeLatest } from 'redux-saga/effects';

import { EIntegrationTypes } from '../../utils/enums';
import httpClient from '../../utils/httpClient';
import { CAMPAIGN_CREATE_REQUEST, CAMPAIGN_ENABLE_INTEGRATION_REQUEST, CAMPAIGN_REMOVE_REQUEST, CAMPAIGN_RESET_REQUEST, CAMPAIGN_SET_NAME_REQUEST } from '../actions/actionTypes';
import { resetCampaignState } from '../actions/campaign';
import { createCampaignError, createCampaignStore, removeCampaignError, removeCampaignSuccess, setCampaignNameUpdate, setTargetIntegrationsUpdate } from '../actions/campaign';
import { removeFromList } from '../actions/campaigns';
import { createPostRequest, resetPostState } from '../actions/post';
import { resetWizardState } from '../actions/wizard';
import { getCampaignId } from '../reducers/campaign';
import { getUserIsAPublish } from '../reducers/user';
import { getCampaignName, getIntegrations } from '../reducers/wizard';

function* campaignNameSaga({ name }) {
  yield put(setCampaignNameUpdate(name));
}

function* enableIntegrationSaga({ payload }) {
  yield put(setTargetIntegrationsUpdate(payload));
}

export function* campaignNameWatcher() {
  yield takeLatest(CAMPAIGN_SET_NAME_REQUEST, campaignNameSaga);
}

export function* campaignCheckSocialWatcher() {
  yield takeLatest(CAMPAIGN_ENABLE_INTEGRATION_REQUEST, enableIntegrationSaga);
}

// create new
function getCreateCampaignApiCall(payload) {
  if (payload.campaignId === null) {
    return httpClient.post(`api/profiles/${payload.profileId}/campaigns`);
  } else {
    return httpClient.put(`api/profiles/${payload.profileId}/campaigns/${payload.campaignId}`, {
      title: payload.title,
      fb: payload.fb,
      tw: payload.tw,
      vk: payload.vk,
      ig: payload.ig,
      ok: payload.ok,
      li: payload.li,
      tg: payload.tg,
    });
  }
}

function* createCampaignSaga() {
  try {
    const title = yield select(getCampaignName);
    const targetIntegrations = yield select(getIntegrations);
    const campaignId = yield select(getCampaignId);
    const userIsAPublish = yield select(getUserIsAPublish);

    const payload = {
      title,
      fb: targetIntegrations.indexOf(EIntegrationTypes.FACEBOOK) !== -1,
      tw: targetIntegrations.indexOf(EIntegrationTypes.TWITTER) !== -1,
      vk: targetIntegrations.indexOf(EIntegrationTypes.VKONTAKTE) !== -1,
      ig: targetIntegrations.indexOf(EIntegrationTypes.INSTAGRAM) !== -1,
      ok: targetIntegrations.indexOf(EIntegrationTypes.ODNOKLASSNIKI) !== -1,
      li: targetIntegrations.indexOf(EIntegrationTypes.LINKEDIN) !== -1,
      tg: targetIntegrations.indexOf(EIntegrationTypes.TELEGRAM) !== -1,
      campaignId: campaignId,
    };

    const { data } = yield call(getCreateCampaignApiCall, payload);

    yield put(createCampaignStore(data));

    if (userIsAPublish) {
      yield put(createPostRequest());
    }
  } catch (error) {
    console.log('createCampaignSaga error', error.toString());

    yield put(createCampaignError(error.Message ? error.Message : error.toString()));
  }
}

export function* createCampaignWatcher() {
  yield takeLatest(CAMPAIGN_CREATE_REQUEST, createCampaignSaga);
}

// remove
function getRemoveCampaignApiCall(payload) {
  // return httpClient.delete(`api/campaigns/${payload.id}${payload.full ? '?full=true' : ''}`);
  return httpClient.delete(`api/profiles/${payload.profileId}/campaigns/${payload.id}`);
}

function* removeCampaignSaga({ payload }) {
  try {
    const { data } = yield call(getRemoveCampaignApiCall, payload);

    yield put(removeCampaignSuccess(data));
    yield put(removeFromList(payload));
  } catch (error) {
    console.log('removeCampaignSaga error', error.toString());

    yield put(removeCampaignError(error.Message ? error.Message : error.toString()));
  }
}

export function* removeCampaignWatcher() {
  yield takeLatest(CAMPAIGN_REMOVE_REQUEST, removeCampaignSaga);
}

// reset state
function* resetCampaignSaga() {
  try {
    // reset states
    yield put(resetWizardState());
    yield put(resetPostState());
    yield put(resetCampaignState());
  } catch (error) {
    console.log('resetCampaignSaga error', error.toString());
  }
}

export function* resetCampaignWatcher() {
  yield takeLatest(CAMPAIGN_RESET_REQUEST, resetCampaignSaga);
}
